module.exports = __webpack_public_path__ + "static/media/ST2 icon.704fae0b.png";